module.exports = __webpack_public_path__ + "c85615b296302af51e683eecb5e371d4.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBold.woff2
// module id = 370
// module chunks = 0